// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlayButton_overlay__3LnwK"};